export default __webpack_public_path__ + "static/media/quiz_bg.03dfcf57.png";